import { computed, ref } from "vue";
import { ActivityLogRow } from "@shared/types/services/activityLog.ts";
import { defineStore } from "pinia";

export const useActivityLogStore = defineStore("activityLog", () => {
  // State
  const _events = ref<ActivityLogRow[]>([]);
  const _eventsAreLoading = ref<boolean>(true);

  // Getters
  const events = computed(() => _events.value);
  const eventsAreLoading = computed(() => _eventsAreLoading.value);

  // Actions
  const setEvents = (newEvents: ActivityLogRow[]) => {
    _events.value = newEvents;
  };

  const setEventsAreLoading = (isLoading: boolean) => {
    _eventsAreLoading.value = isLoading;
  };

  return {
    events,
    eventsAreLoading,
    setEvents,
    setEventsAreLoading,
  };
});
